export const ERR_SYS_001 = "ES001";
const errorsMap = new Map<string, string>();
errorsMap.set("ES001", "ログインして下さい。");

export function getErrorMessage(code:string, orElseMsg = ""):string{
    if(errorsMap.has(code)){
        return errorsMap.get(code);
    }else {
        return orElseMsg;
    }
}

export function isSessionTimeError(code:string):boolean{
    return ERR_SYS_001 === code;
}